import React, { useState } from "react";
import LogNav from "../layout/LoggedNav";
import AddCourses from "../layout/AddedCoursesCard";
import { getAuthData } from "../../services/authService";

const auth = getAuthData();

const AccCourses = () => {
  return (
   
      <section className=" club_Login">
        <div className="page-width">
          <div className="acchome-block gap-block-section">
            <h1 className="acccore--title text-jost-sb-50">
            </h1>
            {/* <LogNav /> */}
            <div className="acccore__wrap">
              <AddCourses />
            </div>
          </div>
        </div>
      </section>
   
  );
};
export default AccCourses;
